// Cliente de la vista del plantel. Pega a Django por el proxy /django-api con
// el JWT del usuario: la org sale del token y, si trae rol `plantel:<nombre>`,
// el servidor amarra todo a esa escuela. Aquí NO se decide qué se puede ver.
import type { Distribucion, Lista, Resumen } from './types';

const DJANGO = '/django-api';
const BASE = '/api/v1/futuria';

function headers(): Record<string, string> {
  const t = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${t ?? ''}` };
}
async function j<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} — ${(await res.text()).slice(0, 200)}`);
  return res.json() as Promise<T>;
}
const q = (p: Record<string, string | number | undefined>) => {
  const s = Object.entries(p)
    .filter(([, v]) => v !== undefined && v !== '' && v !== null)
    .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&');
  return s ? `?${s}` : '';
};

export async function getResumen(escuela?: string): Promise<Resumen> {
  return j<Resumen>(await fetch(`${DJANGO}${BASE}/plantel/resumen${q({ escuela })}`, { headers: headers() }));
}

export async function getAlumnos(p: {
  escuela?: string; estado?: string; buscar?: string; pagina?: number; por_pagina?: number;
} = {}): Promise<Lista> {
  return j<Lista>(await fetch(`${DJANGO}${BASE}/plantel/alumnos${q(p)}`, { headers: headers() }));
}

export async function getDistribucion(escuela?: string): Promise<Distribucion> {
  return j<Distribucion>(await fetch(`${DJANGO}${BASE}/perfil/distribucion${q({ escuela })}`, { headers: headers() }));
}
